module.exports = __webpack_public_path__ + "static/img/ccs.256951f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/itemImgs/ccs.jpg
// module id = F7Ac
// module chunks = 0